module.exports = __webpack_public_path__ + "img/head_share_aktiv.90dedda7.png";